<ng-template #columnsModalTemplate>
  <div class="table-columns-modal">
    <div class="modal-header">
      <ng-container *ngIf="_tableDisplayConfig?.tableConfig?.filter_type === TableFilterDisplayTypeEnum.SINGLE_COLUMN_DROPDOWN_FILTER; else defaultCloseBtn">
        <button type="button" class="btn btn-outline-secondary ms-auto pointer" aria-label="Close" (click)="columnsModal?.hide()">
          {{ 'misc.save_btn' | translate }}
        </button>
      </ng-container>
      <ng-template #defaultCloseBtn>
        <button type="button" class="btn-close close pull-right pointer" aria-label="Close" (click)="columnsModal?.hide()">
          <i class="fa fa-times "></i>
        </button>
      </ng-template>
    </div>

    <div class="modal-body">

      <div class="columns-list"
           cdkDropList
           #modalColumnsList="cdkDropList"
           [cdkDropListData]="columns"
           (cdkDropListDropped)="onColumnDrop($event)"
      >
        <ng-container *ngFor="let column of columns ?? []; let i = index">
          <div class="columns-list-item cursor-grab " cdkDrag>
            <div class="columns-list-item-container row">
              <div class="drag-col col">
                <i class="fa-solid fa-grip-vertical"></i>
              </div>
              <div class="checkbox-col col" (click)="toggleColumn(column)">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox"
                         [checked]="!hiddenColumns.includes(column)">
                </div>
              </div>
              <div class="title-col col" (click)="toggleColumn(column)">
                {{ 'tables.' + _tableDisplayConfig?.tableConfig?.id + '.' + column | translate }}
              </div>
            </div>

          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="_tableDisplayConfig?.tableConfig?.filter_type === TableFilterDisplayTypeEnum.SINGLE_COLUMN_DROPDOWN_FILTER; else defaultResetBtn">
        <button type="button" class="btn btn-outline-secondary" (click)="resetTable.emit()">Reset</button>
      </ng-container>
      <ng-template #defaultResetBtn>
        <button type="button" class="btn btn-danger" (click)="resetTable.emit()">Reset</button>
      </ng-template>
    </div>
  </div>

</ng-template>
